/**
 * useEffectiveOrgFilter -- React wrapper over lib/orgScope.effectiveOrgFilter (OP #1599).
 *
 * Reads the header (ScopeBar) customer from the session store and resolves it against the
 * page's own `?org=` value. Every list page with an in-page customer filter should call this
 * instead of reading `?org=` directly, so "All sites" under a selected customer can never
 * widen to every customer again. See lib/orgScope.ts for the rule and why.
 */
import { useSession } from "@/stores/session";
import { effectiveOrgFilter, type EffectiveOrgFilter } from "@/lib/orgScope";

/**
 * @param urlOrg  the page's `?org=` param (pass `params.get("org")`); ignored when the
 *                header has a customer selected.
 */
export function useEffectiveOrgFilter(urlOrg: string | null | undefined): EffectiveOrgFilter {
  // Select the primitive id, not a derived object: a fresh object per render would make
  // Zustand's Object.is check re-render forever (same trap ScopeBar documents).
  const headerOrgId = useSession((s) => s.currentOrgId);
  return effectiveOrgFilter(headerOrgId, urlOrg);
}
